import React from 'react'

export const Error404 = () => {
  return (
    <div>
      <h1>Error404</h1>
      <p>This Page Does Not Exist</p>
    </div>
  )
}
